var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlameLevel2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 46.02 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#0ba1e2;}.cls-2{fill:#dbdbdb;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Flame level 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16,50.34a21.83,21.83,0,0,0,11.86,1.08c7.1-1.86,11.39-8.09,13-13.45a16.05,16.05,0,0,0,0-9.09c-6.53,9.3-10.61,4.77-10.61,4.77,5.77-5.78,5.21-10.95-.94-16.32C20.78,10,27,0,27,0,9.66,11.55,17.68,28.88,11.9,28.88S6.13,23.1,6.13,23.1C1.63,36.59,7.63,46.57,16,50.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M44.19,64H1.83a1.83,1.83,0,1,1,0-3.66H44.19a1.83,1.83,0,1,1,0,3.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.19,62.17c0-1-2.84-1.83-1.83-1.83H1.83a1.83,1.83,0,1,0,0,3.66h8.53C9.35,64,12.19,63.18,12.19,62.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.5,60.34H7.31c1,0-.61.82-.61,1.83S8.32,64,7.31,64H12.5a1.83,1.83,0,0,0,0-3.66Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlameLevel2);
export default __webpack_public_path__ + "static/media/Flame_level_2.fe2a9f7df7ca4da3e97823ebffdb7937.svg";
export { ForwardRef as ReactComponent };